/**
 *
 * Asynchronously loads the component for FilterAdapter
 *
 */

import { lazyLoad } from 'utils/loadable';

export const FilterAdapter = lazyLoad(
  () => import('./index'),
  module => module.FilterAdapter,
);
